import { ApiRewardsProgram } from '@api/interfaces/ApiRewardsProgram';
import { formatMediumDate } from '@shared/utilities';
import i18next from 'i18next';

export const getProgramPeriodLabel = (program: ApiRewardsProgram) => (
  `${formatMediumDate(program.startDate, i18next)} - ${formatMediumDate(program.endDate, i18next)}`
);

export const sortPrograms = (programs: ApiRewardsProgram[]) => {
  return programs.sort(
    (a, b) => new Date(a.endDate).getTime() - new Date(b.startDate).getTime(),
  ) ?? [];
};
